export const CLOSE_CARD_MENU_EVENT = 'close-card-menu';
